import React, { useState } from 'react';

import { UseBaseTable } from 'hooks/useBaseTable';

import { FilterButton } from 'components/common/FilterButton/FilterButton';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';
import { TextInput } from 'components/DesignSystem/TextInput';
import { UseReportsTableProvider } from 'components/widgets/ReportsHome/ReportsListTable/ReportsListTable.Provider';
import { ProjectsFilter } from 'components/widgets/ReportsHome/ReportsListTable/filters/ProjectFilter/ProjectsFilter';
import { useReportListTableFilterLogic } from 'components/widgets/ReportsHome/ReportsListTable/filters/ReportListTableFilter.logic';
import classes from 'components/widgets/ReportsHome/ReportsListTable/filters/ReportListTableFilter.module.scss';
import { TagsFilter } from 'components/widgets/ReportsHome/ReportsListTable/filters/TagsFilter/TagsFilter';

interface Props {
    table: UseBaseTable['table'];
    api: UseReportsTableProvider['api'];
}

export const ReportListTableFilter = ({ table, api }: Props) => {
    const [search, setSearch] = useState('');
    const [showOnlyFavorites, setShowOnlyFavorites] = useState<boolean>(false);
    const [selectedProjects, setSelectedProjects] = useState<ISelectOption<string>[]>([]);
    const [selectedTag, setSelectedTag] = useState(null);

    const { logic } = useReportListTableFilterLogic({
        table,
        api,
        setSelectedProjects,
        setSelectedTag,
        setSearch,
        setShowOnlyFavorites,
    });

    return (
        <div className={classes.filterContainer}>
            <TextInput
                placeholder={'Search by name...'}
                className={classes.searchField}
                value={search}
                onChange={(e) => logic.handleSearchChange(e.target.value)}
                onClear={() => logic.handleSearchChange('')}
                endIcon={<Icon name={'search'} size={'16px'} color={'var(--text-placeholder)'} />}
            />

            <FilterButton
                isActive={showOnlyFavorites}
                startIcon={<MuiIcon icon={'bookmark_outlined'} type={'outlined'} color={'inherit'} fontSize={'1rem'} />}
                onClick={() => logic.handleShowOnlyFavoritesChange(!showOnlyFavorites)}
            >
                Favorites
            </FilterButton>
            <TagsFilter
                selectedTag={selectedTag}
                handleSelectedTagChange={logic.handleTagSelectionChange}
                tagOptions={logic.tagOptions}
            />
            <ProjectsFilter
                handleOnChange={logic.handleProjectOnChange}
                projectList={logic.getProjectList ?? []}
                selectedProject={selectedProjects}
            />

            <Button
                startIcon={<Icon name={'filter-clear'} size={'15px'} color={'var(--button-secondary-fg)'} />}
                variant={'tertiary'}
                onClick={logic.handleClearAll}
            >
                Clear filters
            </Button>
        </div>
    );
};
